export default "__VITE_ASSET__CCoQHTiV__"